<ag-mail
  [referenceId]="student?.id"
  [service]="studentApiService"
  (send)="openMail($event)"
></ag-mail>
